import { Suspense } from 'react';
import { Redirect } from 'react-router';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import SplashScreen from '../components/splash-screen';
import AuthLayout from '../layout/auth-layout';
import MainLayout from '../layout/main-layout';
import paths from './paths';
import routes from './routes';

function Routing() {
  function GuardedRoute(props) {
    // eslint-disable-next-line react/destructuring-assignment, react/prop-types
    const middleware = props.middleware || [];
    // eslint-disable-next-line react/prop-types
    let finalProps = props;
    for (let i = 0; i < middleware.length; i += 1) {
      const currentMiddleware = middleware[i];
      const response = currentMiddleware(finalProps);
      if (response.action === 'redirect') {
        return <Redirect to={response.data} />;
      }
      if (response.action === 'pass') {
        finalProps = response.data || finalProps;
      }
      if (response.action === 'block') {
        return <Redirect to={paths.participants} />;
      }
    }

    const { component: Component, ...rest } = finalProps;
    return <Route {...rest} render={(routeProps) => <Component {...routeProps} />} />;
  }

  // Find each specific route group
  const appRoutes = routes.find((route) => route.path === '/app/:path?');
  const ndisRoutes = routes.find((route) => route.path === '/ndis/:path?');
  const supportAtHomeRoutes = routes.find((route) => route.path === '/support-at-home/:path?');
  const authRoutes = routes.find((route) => route.layout === AuthLayout);

  return (
    <Router basename="/">
      <Switch>
        {/* App Routes */}
        <Route path="/app">
          <MainLayout>
            <Suspense fallback={<SplashScreen />}>
              <Switch>
                {appRoutes.children.map((route) => (
                  <GuardedRoute key={route.path} exact={route.exact ?? true} {...route} />
                ))}
                <Route path="*">
                  <Redirect to="/app/404" />
                </Route>
              </Switch>
            </Suspense>
          </MainLayout>
        </Route>

        {/* NDIS Routes */}
        <Route path="/ndis">
          <MainLayout>
            <Suspense fallback={<SplashScreen />}>
              <Switch>
                {ndisRoutes.children.map((route) => (
                  <GuardedRoute key={route.path} exact={route.exact ?? true} {...route} />
                ))}
                <Route path="*">
                  <Redirect to="/ndis/404" />
                </Route>
              </Switch>
            </Suspense>
          </MainLayout>
        </Route>

        {/* Support at Home Routes */}
        <Route path="/support-at-home">
          <MainLayout>
            <Suspense fallback={<SplashScreen />}>
              <Switch>
                {supportAtHomeRoutes.children.map((route) => (
                  <GuardedRoute key={route.path} exact={route.exact ?? true} {...route} />
                ))}
                <Route path="*">
                  <Redirect to="/support-at-home/404" />
                </Route>
              </Switch>
            </Suspense>
          </MainLayout>
        </Route>

        {/* Auth Routes */}
        <Route path="/">
          <AuthLayout>
            <Suspense fallback={<SplashScreen />}>
              <Switch>
                {authRoutes.children.map((route) => (
                  <GuardedRoute key={route.path} exact={route.exact ?? true} {...route} />
                ))}
                <Route path="*">
                  <Redirect to="/404" />
                </Route>
              </Switch>
            </Suspense>
          </AuthLayout>
        </Route>
      </Switch>
    </Router>
  );
}

export default Routing;
